import axios from 'axios'

const base = `${process.env.VUE_APP_API}/educational-video`

const getAll = async () => {
  const { data } = await axios.get(base)
  return data
}

const get = async (id) => {
  const { data } = await axios.get(`${base}/${id}`)
  return data
}

const create = async (platform, title, youtubeUrl, active, sortOrder) => {
  const { data } = await axios.post(base, { platform, title, youtubeUrl, active, sortOrder })
  return data
}

const update = async (id, platform, title, youtubeUrl, active, sortOrder) => {
  const { data } = await axios.put(`${base}/${id}`, { platform, title, youtubeUrl, active, sortOrder })
  return data
}

const remove = async (id) => {
  const { data } = await axios.delete(`${base}/${id}`)
  return data
}

export {
  getAll,
  get,
  create,
  update,
  remove
}
